import { render, staticRenderFns } from "./SegmentListCreateOrEditTagsFilter.vue?vue&type=template&id=4bc80032&scoped=true&"
import script from "./SegmentListCreateOrEditTagsFilter.vue?vue&type=script&lang=js&"
export * from "./SegmentListCreateOrEditTagsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc80032",
  null
  
)

export default component.exports